import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  connectBtn: {
    marginTop: 0
  }
})

export default useStyles
